import { FormControlOutline, FormControlUnderline } from './Select.styles';
import { InputLabel, MenuItem, Select } from '@mui/material';
import React, { ElementType, useEffect } from 'react';

import { SelectInputProps } from '@mui/material/Select/SelectInput';
import { useGlobalization } from '../../../../../../i18n/useGlobalization';
import { camelAndSnakeCaseToWords } from '../../utils/helpers';

export interface SystemTypeSelectProps {
	systemType: string;
	onSystemTypeChange: SelectInputProps<string>['onChange'];
	systemTypes: string[];
	systemSchema: Record<string, { displayName?: string }>;
	loadSystemSchema: (system: string) => void;
	topBar?: boolean;
	dataCy?: string;
}

export const SystemTypeSelect = ({
	systemType,
	onSystemTypeChange,
	systemTypes,
	systemSchema,
	loadSystemSchema,
	topBar,
	dataCy,
}: SystemTypeSelectProps): JSX.Element => {
	const { t } = useGlobalization();

	useEffect(() => {
		systemTypes.forEach(system => {
			if (system !== 'SpatialData') loadSystemSchema(system);
		});
	}, [systemTypes]);

	const FormControl: ElementType = topBar
		? FormControlUnderline
		: FormControlOutline;

	return (
		<FormControl>
			<InputLabel shrink={topBar}>{t('Data Type')}</InputLabel>
			<Select
				displayEmpty
				value={systemType}
				onChange={onSystemTypeChange}
				disabled={!systemTypes?.length}
				data-cy={dataCy}>
				{topBar && (
					<MenuItem disabled value="">
						{t('Select a data type')}
					</MenuItem>
				)}
				{systemTypes.map(systemType => (
					<MenuItem key={systemType} value={systemType}>
						{systemSchema[systemType]?.displayName ??
							camelAndSnakeCaseToWords(systemType)}
					</MenuItem>
				))}
			</Select>
		</FormControl>
	);
};
